export default "__VITE_ASSET__e007799b__"